var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ComputeBudgetProgram, LAMPORTS_PER_SOL } from "@solana/web3.js";
export function addPriorityFee(tx, prioritizationFee) {
    return __awaiter(this, void 0, void 0, function () {
        var estimatedFee, writableAccounts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    estimatedFee = prioritizationFee ? prioritizationFee : 0;
                    writableAccounts = tx.instructions
                        .map(function (ix) { return ix.keys.filter(function (key) { return key.isWritable; }).map(function (key) { return key.pubkey.toBase58(); }); })
                        .flat();
                    if (!(estimatedFee === 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getRecentPrioritizationFeesHM(writableAccounts, "https://rpc.hellomoon.io/13bb514b-0e38-4ff2-a167-6383ef88aa10")];
                case 1:
                    estimatedFee = _a.sent();
                    if (estimatedFee < 10000)
                        estimatedFee = 10000;
                    console.log("using getPrioritizationFee from hellomoon", estimatedFee);
                    return [3 /*break*/, 3];
                case 2:
                    console.log("force fees", estimatedFee);
                    _a.label = 3;
                case 3:
                    if (estimatedFee > 0) {
                        tx = tx.add(ComputeBudgetProgram.setComputeUnitPrice({
                            microLamports: estimatedFee,
                        }));
                    }
                    return [2 /*return*/, tx];
            }
        });
    });
}
var getRecentPrioritizationFeesHM = function () {
    var args_1 = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args_1[_i] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (writableAccounts, url) {
        var response, jsonData, data;
        if (writableAccounts === void 0) { writableAccounts = []; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            jsonrpc: "2.0",
                            id: 1,
                            method: "getPrioritizationFee",
                            params: {
                                writableAccounts: writableAccounts,
                                percentiles: [0, 25, 50, 75, 90, 100],
                                lookbackSlots: 100,
                            },
                        }),
                    })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    jsonData = _a.sent();
                    data = jsonData.result.percentileToFee;
                    console.log("getPrioritizationFee:", data);
                    return [2 /*return*/, data["90"]];
            }
        });
    });
};
export function calculateMakerFee(_a) {
    var bids = _a.bids;
    var maxAmount = 0;
    bids.map(function (bid) {
        var amount = makerFee({ bid: bid });
        maxAmount = Math.max(maxAmount, amount);
    });
    if (maxAmount <= 0) {
        console.log("Maker will receive funds, no fees to deposit " +
            maxAmount +
            " ( " +
            maxAmount / LAMPORTS_PER_SOL +
            " ) lamports");
        return;
    }
    console.log("Wrapping " + maxAmount + " ( " + maxAmount / LAMPORTS_PER_SOL + " ) lamports to wSOL");
    return maxAmount;
}
export function makerFee(_a) {
    var bid = _a.bid;
    return -bid.amount + bid.makerNeoswapFee + bid.makerRoyalties;
}
export function takerFee(_a) {
    var bid = _a.bid, n = _a.n;
    var takerAmount;
    if (n === 42) {
        console.log("fees waived");
        takerAmount = bid.amount;
    }
    else
        takerAmount = bid.amount + bid.takerNeoswapFee + bid.takerRoyalties;
    if (takerAmount <= 0) {
        console.log("Taker will receive funds, no fees to deposit " +
            takerAmount +
            " ( " +
            takerAmount / LAMPORTS_PER_SOL +
            " ) lamports");
    }
    else {
        console.log("Wrapping " +
            takerAmount +
            " ( " +
            takerAmount / LAMPORTS_PER_SOL +
            " ) lamports to wSOL");
    }
    return takerAmount;
}
